import type { CompletionContext, CompletionResult, Completion } from '@codemirror/autocomplete';

export interface RefSuggestion {
  label: string;
  path: string;
  type: 'kb' | 'collection' | 'document';
  icon: string;
}

/**
 * Creates a CM6 autocompletion source that activates inside @ref( ... ).
 * Suggests knowledge bases, collections, and documents from the provided list.
 */
export function refAutocompleteSource(suggestions: RefSuggestion[]) {
  return function refComplete(context: CompletionContext): CompletionResult | null {
    // Find the nearest @ref( before the cursor
    const line = context.state.doc.lineAt(context.pos);
    const textBefore = line.text.slice(0, context.pos - line.from);

    const refStart = textBefore.lastIndexOf('@ref(');
    if (refStart === -1) return null;

    // Check we're inside the parens (no closing paren yet)
    const afterRef = textBefore.slice(refStart + 5);
    if (afterRef.includes(')')) return null;

    const from = line.from + refStart + 5;
    const filter = afterRef.toLowerCase();

    const completions: Completion[] = suggestions
      .filter((s) => s.path.toLowerCase().startsWith(filter))
      .map((s) => ({
        label: `${s.icon} ${s.path}`,
        apply: `${s.path})`,
        type: s.type === 'document' ? 'text' : 'keyword',
        boost: s.type === 'document' ? 2 : s.type === 'collection' ? 1 : 0,
      }));

    if (completions.length === 0) return null;

    return {
      from,
      options: completions,
      validFor: /^[^)]*$/,
    };
  };
}
